export default "__VITE_ASSET__DJwzghjr__"